import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_7 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-black" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black pe-0 text-end" }
const _hoisted_11 = {
  class: "dropdown-menu dropdown-block",
  style: {"position":"absolute","inset":"0px auto auto 0px","margin":"0px","transform":"translate(267px, 305px)"},
  "data-popper-placement": "bottom-start"
}
const _hoisted_12 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddServiceModal = _resolveComponent("AddServiceModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
          _createElementVNode("a", {
            class: "btn btn-primary",
            href: "#",
            "data-bs-toggle": "modal",
            "data-bs-target": "#AddServiceModal"
          }, [
            _createElementVNode("i", { class: "fa fa-plus-circle" }),
            _createTextVNode(" Ajouter un service ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher un service"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "code "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "Libelle "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "Cout "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
                }, " Actions")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(service.code), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(service.libelle), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(service.cout), 1),
                  _createElementVNode("td", _hoisted_10, [
                    _cache[7] || (_cache[7] = _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, "Actions", -1)),
                    _createElementVNode("ul", _hoisted_11, [
                      _createElementVNode("li", _hoisted_12, [
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.moddifier(service))
                        }, _cache[5] || (_cache[5] = [
                          _createElementVNode("i", { class: "flaticon-pen lh-2 me-8 position-relative top-1" }, null, -1),
                          _createTextVNode(" Modifier ")
                        ]), 8, _hoisted_13)
                      ]),
                      _createElementVNode("li", _hoisted_14, [
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.suppression(service.id, _ctx.services, 'services', `le service ${service.libelle}`))
                        }, _cache[6] || (_cache[6] = [
                          _createElementVNode("i", { class: "flaticon-delete lh-2 me-8 position-relative top-1" }, null, -1),
                          _createTextVNode(" Supprimer ")
                        ]), 8, _hoisted_15)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddServiceModal, {
      onGetAllServices: _ctx.getAllServices,
      id: _ctx.idservice,
      onOpenmodal: _ctx.showModalEdite,
      onClose: _ctx.recharger,
      onRefreshServices: _ctx.refreshServices
    }, null, 8, ["onGetAllServices", "id", "onOpenmodal", "onClose", "onRefreshServices"])
  ], 64))
}